<template>
  <div>
    <page-header
      class="page-banner"
      title="Initiatives"
    />
    <content-loader v-if="$apollo.loading" />
    <div class="container initiatives" v-else>
      <div v-for="category in categories" :key="category.id" :id="category.id">
        <div class="cs-textstyle-page-subtitle page-title">
          {{ category.title }}
        </div>
        <div class="row">
          <div
            v-for="initiative in category.initiatives"
            :key="initiative.id"
            class="col-md-4"
          >
            <cs-card class="cs-card" @click="goToForm">
              <img slot="media" :src="initiative.picture" />
              <div slot="header">
                <div class="cs-textstyle-item-heading">
                  {{ initiative.title }}
                </div>
              </div>
              <div slot="body">
                <div class="cs-textstyle-paragraph">
                  {{ initiative.description }}
                </div>
              </div>
            </cs-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/global/PageHeader';
import ListInitiatives from '@/newgql/ListInitiatives.gql';
import ContentLoader from '@/components/global/ContentLoader';

export default {
  components: {
    PageHeader,
    ContentLoader
  },
  apollo: {
    categories: {
      query: ListInitiatives
    }
  },
  methods: {
    goToForm() {
      window.open('https://csuitecircle.typeform.com/to/fEytYh02');
    }
  }
};
</script>

<style lang="scss" scoped>
.initiatives {
  padding-bottom: 100px;
}
.row .cs-card {
  margin: 10px;
  cursor: pointer;
}
.row .col-md-4 {
  padding: 0;
}
.page-title {
  margin: 20px 0px;
}
</style>
